<div class="d-flex align-items-center justify-content-between consultant_wrapper">
  <div class="mt-3">
    <h3>Clients Assigment History</h3>
  </div>
  <div>
    <button type="button" class="btn btn-save theme-btn-color" (click)="openFormModal()">Add Assignment</button>
  </div>
</div>

<div *ngIf="auditHistory.length > 0" class="consultant_wrapper mt-4">
  <div class="document-wrapper mb-5">
    <div class="mx-height-scroll mt-4">

      <table class="table table-striped">
        <thead class="tableview theme-bg-color">
        <tr>
          <th>Client Name</th>
          <th>Contract Start Date</th>
          <th>Contract End Date</th>
          <th>Contract Period</th>
<!--          <th>Tier of Engagement</th>-->
          <th>Type of Engagement</th>
          <th>Job of Location</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let audit of auditHistory">
          <tr>
            <td style="width: 13%">{{ audit.customerName }}</td>
            <td style="width: 13%">{{ audit.contractStartDate | date: ' d MMM y' }}</td>
            <td style="width: 13%">{{ audit.contractEndDate | date: ' d MMM y' }}</td>
            <td style="width: 13%">{{ audit.contractPeriod }}</td>
<!--            <td style="width: 13%">{{ audit.tier }}</td>-->
            <td style="width: 13%">{{ modifyTypeOfEngagement(audit.engagementCategory) }}</td>
            <td style="width: 13%">{{ audit.workMode }}</td>
            <td style="width: 8%">
              <mat-icon class="me-2 cursor-p" (click)="editFormModal(audit.id)"><span class="badge text-white">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V6C3 5.45 3.19567 4.97933 3.587 4.588C3.979 4.196 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.021 4.196 20.413 4.588C20.8043 4.97933 21 5.45 21 6V12H19V10H5V20H12V22H5ZM22.125 17L20 14.875L20.725 14.15C20.9083 13.9667 21.1417 13.875 21.425 13.875C21.7083 13.875 21.9417 13.9667 22.125 14.15L22.85 14.875C23.0333 15.0583 23.125 15.2917 23.125 15.575C23.125 15.8583 23.0333 16.0917 22.85 16.275L22.125 17ZM14 23V20.875L19.3 15.575L21.425 17.7L16.125 23H14Z"
                            fill="#545454"/>
                          </svg>
                         </span></mat-icon>
              <mat-icon (click)="deleteRow(audit.id)">
                <span class="badge text-white cursor-p">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M20.37 8.91003L19.37 10.64L7.24 3.64003L8.24 1.91003L11.28 3.66003L12.64 3.29003L16.97 5.79003L17.34 7.16003L20.37 8.91003ZM6 19V7.00003H11.07L18 11V19C18 19.5305 17.7893 20.0392 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H8C7.46957 21 6.96086 20.7893 6.58579 20.4142C6.21071 20.0392 6 19.5305 6 19Z"
                            fill="#ED0F0F"/>
                          </svg>
                      </span>
              </mat-icon>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
    <div *ngIf="totalPages > 1">
      <mat-paginator [length]="totalElements"
                     [pageSizeOptions]="[5,10,12,25,50,100]"
                     (page)="handlePage($event)"
                     aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
</div>
<div *ngIf="auditHistory.length == 0" class="empty-state d-flex justify-content-center themeSecondary-bg-color fs-6 mt-3">
  <span>Currently no active Clients Assigment History available</span>
</div>
